import { DisabledStyles } from 'components/Generics/Style/DisabledStyle';
import styled from 'styled-components';
import theme from 'theme';

export const RowContainer = styled.div<{ isSelected: boolean, isDisabled: boolean }>`
    display: flex;
    align-items: center;
    padding: 15px 20px;
    border: 1px solid ${theme.lightGrey};
    position: relative;
    background-color: ${({ isSelected }) => (isSelected ? theme.mintLight : 'transparent')};
    &:hover {
        cursor: ${({ isDisabled }) => isDisabled ? 'default' : 'pointer'};
        background-color: ${({ isDisabled, isSelected }) => !isDisabled && !isSelected ? theme.lightestGrey : undefined};
    }
    ${({ isDisabled, isSelected }) => isDisabled && !isSelected ? DisabledStyles : undefined}
`;

export const PoolNameText = styled.span<{ isSelected: boolean }>`
    font-size: 14px;
    font-weight: ${({ isSelected }) => (isSelected ? 500 : 400)};
    display: flex;
    margin-left: 10px;
    color: ${theme.sherpaBlue};
`;

export const RowTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 5px;
    color: ${theme.sherpaBlue};
    margin-right: 10px;
`;

export const PoolIdRowText = styled.span`
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 5px;
`;

export const DomainNameRowText = styled.span`
    font-size: 12px;
`;

export const Separator = styled.span`
    margin: 0 10px;
    font-size: 40px;
    color: ${theme.lightGrey};
`;

export const RowStatusText = styled.span`
    color: ${theme.sherpaBlue};
    font-size: 14px;
    margin-left: auto;
    font-weight: 500;
`;

export const RadioWrapper = styled.label<{ isSelected: boolean }>`
    position: relative;
    display: inline-block;
    width: 15px;
    height: 15px;
    min-width: 15px;
    min-height: 15px;
    background: ${theme.white};
    border-radius: 50%;
    border: 2px solid ${theme.sherpaBlue};

    &::before {
        content: '';
        position: absolute;
        top: 1.5px;
        left: 1.5px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: ${({ isSelected }) => (isSelected ? theme.sherpaBlue : theme.white)};
        transition: background 0.2s;
    }
`;

export const RadioInput = styled.input`
    opacity: 0;
    position: absolute;
    margin: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;

    &:checked + ${RadioWrapper}::before {
        background: ${theme.sherpaBlue};
    }
`;
